<div class="weeklyplanningpreview papercard">
  @for (day of this.daylyStatuses; track day) {
<div>
    <app-daily-status [status]="day.status" [day]="day.day" />
  </div>
}
</div>
